import type { CSSProperties, FC, ReactNode } from 'react'

import { cn } from '@/lib/utils'
import SplitWords from '@/components/motion/split-words'

interface PageIntroProps {
    eyebrow: string
    title: string
    description?: string
    className?: string
    children?: ReactNode
}

/** The opening block of an inner page, with the same load sequence as the home hero. */
const PageIntro: FC<PageIntroProps> = ({ eyebrow, title, description, className, children }): ReactNode => {
    return (
        <div className={cn('flex max-w-2xl flex-col gap-5', className)}>
            <span className='eyebrow intro-rise' style={{ '--intro-delay': '120ms' } as CSSProperties}>
                {eyebrow}
            </span>

            <SplitWords
                as='h1'
                mode='load'
                delay={180}
                text={title}
                className='font-heading text-[clamp(2.4rem,5.6vw,4rem)] font-normal leading-[1.03] tracking-[-0.03em] text-balance'
            />

            {description && (
                <p className='intro-rise max-w-xl text-pretty text-base leading-relaxed text-ink-muted sm:text-lg' style={{ '--intro-delay': '480ms' } as CSSProperties}>
                    {description}
                </p>
            )}

            {children}
        </div>
    )
}

export default PageIntro
